module.exports = __webpack_public_path__ + "static/media/fragt-green.42e211d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/fragt-green.svg
// module id = 576
// module chunks = 0